module.exports = __webpack_public_path__ + "static/WpK_lazienka_pakiet_zloty-00331f7eedc8c54d7b56c306f2746b1e.jpg";